import React from 'react';
import ScrollableContainer from 'components/shared/scrollable';
import LessonVersionList from './LessonVersionList';
import ScormLessonVersionList from './ScormLessonVersionList';

const PublishedVersionCollection = props => {
  const { versions, currentVersion, isScormLesson, totalVersions } = props;
  const lastLiRef = React.createRef();

  const containerRef = React.createRef();

  const handleScroll = () => {
    if (versions.length === totalVersions) {
      return;
    }
    const container = containerRef.current;
    const containerBounding = container.getBoundingClientRect();
    const lastLi = lastLiRef.current;
    const lastLiBounding = lastLi.getBoundingClientRect();

    if (lastLiBounding.bottom < containerBounding.bottom) {
      props.setLessonVersionState(prevState => ({
        ...prevState,
        page: prevState.page + 1,
      }));
    }
  };

  return (
    <ScrollableContainer
      onScroll={e => {
        handleScroll(e);
      }}
      ref={containerRef}
      className="PublishedVersionCollection-scrollable bg-white pr-0"
      maxHeight={null}
    >
      {!isScormLesson && (
        <LessonVersionList
          versions={versions}
          currentVersion={currentVersion}
          lastLiRef={lastLiRef}
        />
      )}
      {isScormLesson && (
        <ScormLessonVersionList
          versions={versions}
          currentVersion={currentVersion}
          lastLiRef={lastLiRef}
        />
      )}
    </ScrollableContainer>
  );
};

export default PublishedVersionCollection;
